module.exports = __webpack_public_path__ + "img/file-icon_wav.4ced8256.svg";